/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nondadocuments3Inputs */

const en_coinvestments_nondadocuments3 = /** @type {(inputs: Coinvestments_Nondadocuments3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No NDA documents found`)
};

/**
* | output |
* | --- |
* | "No NDA documents found" |
*
* @param {Coinvestments_Nondadocuments3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nondadocuments3 = /** @type {((inputs?: Coinvestments_Nondadocuments3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nondadocuments3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nondadocuments3(inputs)
});
export { coinvestments_nondadocuments3 as "coInvestments_noNdaDocuments" }